import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import api from '../utils/api';

// «✏ Править» (14.10.2026): документ .docx открывается для правки прямо в CRM, «Сохранить» перезаписывает файл
// на сервере (прежняя версия — в архиве версий, 20 последних). Поля, шрифт, выравнивание, жирный/курсив,
// «шапка» справа и красная строка сохраняются; таблицы и картинки не поддерживаются — такие файлы не открываются.
// Вариант «открыть в Word с компьютера» (WebDAV) оставлен на сервере, но у пользователя Word ссылку не принял.
const MODULES = { toolbar: [['bold', 'italic', 'underline'], [{ align: [] }], [{ indent: '-1' }, { indent: '+1' }], ['clean']] };
const FORMATS = ['bold', 'italic', 'underline', 'align', 'indent'];

// Печать .docx без открытия редактора: сервер делает PDF, браузер открывает окно печати
export function printDoc(type, id, onReady) {
  const url = `/api/doc-edit/pdf?type=${type}&id=${id}&t=${Date.now()}`;
  const fr = document.createElement('iframe');
  fr.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
  fr.src = url;
  fr.onload = () => {
    onReady && onReady();
    try { fr.contentWindow.focus(); fr.contentWindow.print(); } catch { window.open(url, '_blank'); }
    setTimeout(() => fr.remove(), 60000);
  };
  document.body.appendChild(fr);
}

export default function WordEditButton({ type, f, showToast, onSaved }) {
  const [doc, setDoc] = useState(null);      // { html, name }
  const [html, setHtml] = useState('');
  const [dirty, setDirty] = useState(false);
  const [saving, setSaving] = useState(false);
  const [printing, setPrinting] = useState(false);
  if (!/\.docx$/i.test(f.original_name || '')) return null;
  const toast = (m, t) => showToast && showToast(m, t);

  const open = () => api.get('/doc-edit/html', { params: { type, id: f.id } })
    .then(r => { setDoc(r.data); setHtml(r.data.html); setDirty(false); })
    .catch(e => toast(e.response?.data?.error || 'Не удалось открыть документ', 'error'));
  const close = () => { if (dirty && !window.confirm('Изменения не сохранены. Закрыть без сохранения?')) return; setDoc(null); };
  const save = (thenClose) => {
    setSaving(true);
    api.post('/doc-edit/save', { type, id: f.id, html })
      .then(() => { toast('Документ сохранён'); setDirty(false); onSaved && onSaved(); if (thenClose) setDoc(null); })
      .catch(e => toast(e.response?.data?.error || 'Не удалось сохранить', 'error'))
      .finally(() => setSaving(false));
  };

  // печать: сначала сохраняем несохранённое, затем PDF с сервера печатается через скрытый iframe
  const print = async () => {
    if (dirty) { try { await api.post('/doc-edit/save', { type, id: f.id, html }); setDirty(false); onSaved && onSaved(); } catch (e) { return toast(e.response?.data?.error || 'Не удалось сохранить перед печатью', 'error'); } }
    setPrinting(true);
    printDoc(type, f.id, () => setPrinting(false));
  };

  return <>
    <button className="btn btn-secondary btn-sm" title="Править документ прямо в CRM" onClick={open}>✏ Править</button>
    {doc && (
      <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(15,23,42,.55)', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '16px 8px', overflow: 'auto' }}>
        <div style={{ width: '100%', maxWidth: 900, display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8, color: '#fff', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 200, fontWeight: 600, fontSize: 14 }}>{doc.name}{dirty ? ' · не сохранено' : ''}</div>
          <button className="btn btn-primary btn-sm" disabled={saving || !dirty} onClick={() => save(false)}>{saving ? 'Сохраняю…' : 'Сохранить'}</button>
          <button className="btn btn-secondary btn-sm" disabled={saving} onClick={() => dirty ? save(true) : setDoc(null)}>Сохранить и закрыть</button>
          <button className="btn btn-secondary btn-sm" disabled={saving || printing} onClick={print}>{printing ? 'Готовлю…' : '🖨 Печать'}</button>
          <button className="btn btn-secondary btn-sm" onClick={close}>Закрыть</button>
        </div>
        <div className="doc-editor" style={{ width: '100%', maxWidth: 900, background: '#fff', borderRadius: 6 }}>
          <ReactQuill theme="snow" value={html} modules={MODULES} formats={FORMATS}
            onChange={(v, delta, source) => { setHtml(v); if (source === 'user') setDirty(true); }} />
        </div>
        <div style={{ color: '#e2e8f0', fontSize: 12, marginTop: 8, maxWidth: 900 }}>
          Поля, шрифт и оформление документа сохранятся. Прежняя версия остаётся на сервере — при ошибке её можно вернуть.
        </div>
      </div>
    )}
  </>;
}
